<template>

    <div class="top-row">
        <h1 class="wizard-title"> Salut {{ user.name }}</h1>
        <nav><span class="wizard-mini-title">{{ copydeck.wizardTitle }}</span> <span
            class="current-page">{{ currentGroupIndex }}</span> | <span class="total-num-pages">{{
                totalGroupCount
            }}</span></nav>
    </div>

    <div class="introduction-section" v-if=" currentGroupIndex === 1 ">
        <div class="introduction">
            <span v-html=" user.isProf ? copydeck.wizardOverviewIntroProfs :  copydeck.wizardOverviewIntro"></span>
            <div class="bg-kids">
                <div class="frame"></div>
            </div>
        </div>
    </div>

    <form-wizard-page
        ref="wizard"
        @change-screen="(e) => emits('change-screen', e)"
    ></form-wizard-page>

</template>

<script>
export default {
    name : "Profile",
}
</script>

<script setup>


import { computed, onMounted, ref } from "vue";
import { useStore }            from "vuex";
import useCopydeck             from "../composables/UseCopydeck";
import FormWizardPage          from "./FormWizardPage.vue";


let store    = useStore();
let copydeck = useCopydeck();

let emits = defineEmits( [ "change-screen", "reset-args" ] );
let props = defineProps( [ "args" ] )

let user              = computed( () => store.state.user );
let currentGroupIndex = computed( () => store.state.currentGroup + 1 );
let totalGroupCount   = computed( () => store.state.totalGroup );

let wizard              = ref (null );


function mounted ()
{
    let strGroup = props.args.group ?? "";


    let indexGroup = store.state.form.data.groups.findIndex( g => g.key === strGroup );

    if ( indexGroup >= 0 )
    {
        setTimeout( () => store.commit( "currentGroup", indexGroup ), 1 );
        emits( "reset-args", "group" );
    }


}

function clearError (strField)
{
    wizard.clearError(strField);
}


defineExpose( { clearError });


onMounted( mounted );

</script>


